/* eslint-disable */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomDatePicker from '@shared/customComponents/CustomDatePicker/CustomDatePicker';
import { getRoomRatios, getRooms } from '@/app/services/reports/reports';
import * as Actions from '@/app/store/actions';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	CircularProgress,
	FormControl,
	IconButton,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { useNavigate } from 'react-router-dom';
import './Reports.css';

export default function RoomRatio() {
	const dispatch = useDispatch();
	const user = useSelector(({ auth }) => auth.user);
	const navigate = useNavigate();
	const [rows, setRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const roomratioRef = useRef(null);
	const [filters, setFilters] = useState({
		export_id: 0,
		room_id: '',
		date: '',
		interval: '',
		room_name: '',
	});
	const [rooms, setRooms] = useState([]);
	const report_date = new Date();
	const [roomPage, setRoomPage] = useState(1);
	const [isLoadingExport, setIsLoadingExport] = useState(false);

	useEffect(() => {
		let isMounted = true;
		getRooms('', roomPage)
			.then((res) => {
				if (!isMounted) return;
				setRooms([...rooms, ...res.data.data]);
				if (res.data.current_page < res.data.last_page) {
					setRoomPage(roomPage + 1);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get rooms.',
						autoHideDuration: 1500,
						variant: 'error',
					}),
				);
			});

		return () => {
			isMounted = false;
		};
	}, [roomPage, dispatch]);

	const calculateRemainingSlots = (date, interval, slots) => {
		// if date is not today
		// date.slice(0,-1) to remove the z so it is not treated as utc date and timezone coversion does not change date
		console.log(moment(date.slice(0, -1)).format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'));
		if (moment(date.slice(0, -1)).format('YYYY-MM-DD') !== moment().format('YYYY-MM-DD')) {
			switch (interval) {
				case 'fifteen': {
					const totalSlots = 13 * 4;
					const remainingSlots = totalSlots - slots.length;
					for (let i = 0; i < remainingSlots; i += 1) {
						slots.push({
							staff_count: slots.slice(-1)[0]?.staff_count || 0,
							student_count: slots.slice(-1)[0]?.student_count || 0,
							start_time: moment(`2022-12-01T${slots.slice(-1)[0]?.start_time}` || '2022-12-01T06:00:00') // here date does not matter, we only need time
								.add(15, 'minutes')
								.format('HH:mm'),
							end_time: moment(`2022-12-01T${slots.slice(-1)[0]?.end_time}` || '2022-12-01T19:00:00')
								.add(15, 'minutes')
								.format('HH:mm'),
						});
					}
					break;
				}
				case 'thirty': {
					const totalSlots = 13 * 2;
					const remainingSlots = totalSlots - slots.length;
					for (let i = 0; i < remainingSlots; i += 1) {
						slots.push({
							staff_count: slots.slice(-1)[0]?.staff_count || 0,
							student_count: slots.slice(-1)[0]?.student_count || 0,
							start_time: moment(`2022-12-01T${slots.slice(-1)[0]?.start_time}` || '2022-12-01T06:00:00')
								.add(30, 'minutes')
								.format('HH:mm'),
							end_time: moment(`2022-12-01T${slots.slice(-1)[0]?.end_time}` || '2022-12-01T19:00:00')
								.add(30, 'minutes')
								.format('HH:mm'),
						});
					}
					break;
				}
				case 'sixty': {
					const totalSlots = 13;
					const remainingSlots = totalSlots - slots.length;
					for (let i = 0; i < remainingSlots; i += 1) {
						slots.push({
							staff_count: slots.slice(-1)[0]?.staff_count || 0,
							student_count: slots.slice(-1)[0]?.student_count || 0,
							start_time: moment(`2022-12-01T${slots.slice(-1)[0]?.start_time}` || '2022-12-01T06:00:00')
								.add(60, 'minutes')
								.format('HH:mm'),
							end_time: moment(`2022-12-01T${slots.slice(-1)[0]?.end_time}` || '2022-12-01T19:00:00')
								.add(60, 'minutes')
								.format('HH:mm'),
						});
					}
					break;
				}
				default: {
					break;
				}
			}
		} else {
			// only add slots till current time
			const currentTime = moment().format('HH:mm:ss');
			switch (interval) {
				case 'fifteen': {
					const totalSlots = 13 * 4;
					const remainingSlots = totalSlots - slots.length;
					for (let i = 0; i < remainingSlots; i += 1) {
						slots.push({
							staff_count: slots.slice(-1)[0]?.staff_count || 0,
							student_count: slots.slice(-1)[0]?.student_count || 0,
							start_time: moment(`2022-12-01T${slots.slice(-1)[0]?.start_time}` || '2022-12-01T06:00:00')
								.add(15, 'minutes')
								.format('HH:mm:ss'),
							end_time: moment(`2022-12-01T${slots.slice(-1)[0].end_time}` || '2022-12-01T19:00:00')
								.add(15, 'minutes')
								.format('HH:mm:ss'),
						});
						if (moment(slots.slice(-1)[0].start_time).format('HH:mm:ss') > currentTime) {
							slots.pop();
							break;
						}
					}
					break;
				}
				case 'thirty': {
					const totalSlots = 13 * 2;
					const remainingSlots = totalSlots - slots.length;
					for (let i = 0; i < remainingSlots; i += 1) {
						slots.push({
							staff_count: slots.slice(-1)[0]?.staff_count || 0,
							student_count: slots.slice(-1)[0]?.student_count || 0,
							start_time: moment(`2022-12-01T${slots.slice(-1)[0]?.start_time}` || '2022-12-01T06:00:00')
								.add(30, 'minutes')
								.format('HH:mm:ss'),
							end_time: moment(`2022-12-01T${slots.slice(-1)[0].end_time}` || '2022-12-01T19:00:00')
								.add(30, 'minutes')
								.format('HH:mm:ss'),
						});
						if (moment(slots.slice(-1)[0].start_time).format('HH:mm:ss') > currentTime) {
							slots.pop();
							break;
						}
					}
					break;
				}
				case 'sixty': {
					const totalSlots = 13;
					const remainingSlots = totalSlots - slots.length;
					console.log('remainingSlots', remainingSlots);
					console.log(slots.slice(-1));
					for (let i = 0; i < remainingSlots; i += 1) {
						slots.push({
							staff_count: slots.slice(-1)[0]?.staff_count || 0,
							student_count: slots.slice(-1)[0]?.student_count || 0,
							start_time: moment(`2022-12-01T${slots.slice(-1)[0]?.start_time}` || '2022-12-01T06:00:00')
								.add(60, 'minutes')
								.format('HH:mm:ss'),
							end_time: moment(`2022-12-01T${slots.slice(-1)[0].end_time}` || '2022-12-01T19:00:00')
								.add(60, 'minutes')
								.format('HH:mm:ss'),
						});
						if (moment(slots.slice(-1)[0].start_time).format('HH:mm:ss') > currentTime) {
							slots.pop();
							break;
						}
					}
					break;
				}
				default: {
					break;
				}
			}
		}
		return slots;
	};

	const ApplyFilters = () => {
		setRows([]);
		setIsLoading(true);
		setFirstLoad(false);
		getRoomRatios(filters.export_id, filters.room_id, filters.date, filters.interval, filters.room_name)
			.then((res) => {
				if (!res.data.roomRatios) {
					setRows([]);
					setIsLoading(false);
					return;
				}
				if (filters.interval === 'fifteen') {
					setFirstLoad(false);
					if (res.data.roomRatios.fifteen.length > 0) {
						const remainingSlots = calculateRemainingSlots(
							res.data.roomRatios.date,
							filters.interval,
							res.data.roomRatios.fifteen,
						);
						setRows(remainingSlots || []);
					} else {
						setRows([]);
					}
				} else if (filters.interval === 'thirty') {
					setFirstLoad(false);
					if (res.data.roomRatios.thirty.length > 0) {
						const remainingSlots = calculateRemainingSlots(
							res.data.roomRatios.date,
							filters.interval,
							res.data.roomRatios.thirty,
						);
						setRows(remainingSlots || []);
					} else {
						setRows([]);
					}
				} else {
					setFirstLoad(false);
					if (res.data.roomRatios.sixty.length > 0) {
						const remainingSlots = calculateRemainingSlots(
							res.data.roomRatios.date,
							filters.interval,
							res.data.roomRatios.sixty,
						);
						console.log(remainingSlots);
						setRows(remainingSlots || []);
					} else {
						setRows([]);
					}
				}
				dispatch(
					Actions.showMessage({
						message: 'Report has been generated',
						variant: 'success',
					}),
				);
			})
			.catch((err) => {
				console.log(err);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					}),
				);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const handleExport = () => {
		if (!filters.interval || !filters.date || !filters.room_id) {
			dispatch(
				Actions.showMessage({
					message: 'Please select all the filters',
					variant: 'error',
				}),
			);
			return;
		}
		setIsLoadingExport(true);
		getRoomRatios(1, filters.room_id, filters.date, filters.interval, filters.room_name)
			.then((res) => {
				const blob = new Blob([res.data], {
					type: 'text/csv',
				});
				const link = document.createElement('a');
				link.setAttribute('target', '_blank');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', `RoomRatio_report_${new Date().getTime()}.csv`);
				document.body.appendChild(link);
				link.click();
				// Clean up and remove the link
				link.parentNode.removeChild(link);
				setIsLoadingExport(false);
			})
			.catch((err) => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to Export',
						variant: 'error',
					}),
				);
				setIsLoadingExport(false);
			})
			.finally(() => {
				setIsLoadingExport(false);
			});
	};

	const handlePrint = useReactToPrint({
		content: () => roomratioRef.current,
	});

	const handleFilters = (ev) => {
		const { name, value } = ev.target;
		setFilters({ ...filters, [name]: value });
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="mx-auto enrolled-cont">
				<div className="flex items-center justify-between">
					<div className="reports-topDiv">
						<h1 className="my-16">
							<span className="">
								<IconButton
									onClick={() => {
										navigate(-1);
									}}
								>
									<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
								</IconButton>
							</span>
							<span className="text-pd-xl self-end font-bold mr-28">Ratio</span>
						</h1>
						<p>
							Historical staff and student count and the associated student: staff ratio by room, with the option to
							choose <br />
							15-minute, 30-minute, or 1-hour intervals
						</p>
					</div>
					<div className="flex justify-between">
						<div className="flex items-center justify-between">
							<div className="">
								<span>
									{!isLoadingExport ? (
										<a>
											<CustomButton
												height="40px"
												marginRight="17px"
												onClick={handleExport}
												variant="primary"
												width="100px"
											>
												<span className="mr-4">
													<FontAwesomeIcon icon={faDownload} />
												</span>
												Export
											</CustomButton>
										</a>
									) : (
										<div className="circle-bar">
											<CircularProgress size={35} />
										</div>
									)}
									<CustomButton height="40px" onClick={() => handlePrint()} variant="secondary" width="100px">
										<i aria-hidden="true" className="fa fa-print" /> Print
									</CustomButton>
								</span>
							</div>
						</div>
					</div>
				</div>

				<div className="flex items-center flex-nowrap justify-between">
					<span className="text-pd-2xl self-end font-extrabold mr-28" />
					<div className="flex justify-between">
						<div className="flex">
							<div className="mx-8">
								<FormControl>
									<InputLabel id="roomLabel"> Room</InputLabel>
									<Select
										endAdornment={
											filters.room_id ? (
												<IconButton className="mr-16" id="clear-room-filter" size="small">
													<Close
														fontSize="small"
														onClick={() => {
															setFilters({
																...filters,
																room_id: '',
																room_name: '',
															});
														}}
													/>
												</IconButton>
											) : (
												''
											)
										}
										id="room_id"
										label="Room"
										labelId="roomLabel"
										name="room_id"
										onChange={(ev) => {
											setFilters({
												...filters,
												room_id: ev.target.value.id,
												room_name: ev.target.value.name,
											});
										}}
										style={{ width: 160 }}
										value={rooms.filter((room) => room.id === filters.room_id)[0] || null}
									>
										{rooms.length ? (
											rooms.map((room) => {
												return (
													<MenuItem id={room.id} key={room.id} value={room}>
														{room.name}
													</MenuItem>
												);
											})
										) : (
											<MenuItem disabled>Loading...</MenuItem>
										)}
									</Select>
								</FormControl>
							</div>
							<div className="mx-10 student-date-field" style={{ width: 160 }}>
								<CustomDatePicker
									disableFuture
									id="date-from"
									label="Date"
									value={filters.date}
									// disabled={!filters.room_id}
									setValue={(Date) => {
										setFilters({ ...filters, date: Date?.format('YYYY-MM-DD') || '' });
									}}
								/>
							</div>
							<div className="mx-8">
								<FormControl>
									<InputLabel id="interval">Interval</InputLabel>
									<Select
										className="interval-select interval-time"
										endAdornment={
											filters.interval ? (
												<div className="flex">
													<IconButton className="mr-16" id="clear-room-filter" size="small">
														<Close
															fontSize="small"
															onClick={() => {
																setFilters({
																	...filters,
																	interval: '',
																});
															}}
														/>
													</IconButton>
												</div>
											) : (
												''
											)
										}
										id="interval"
										label="Time Interval"
										labelId="interval"
										name="interval"
										onChange={handleFilters}
										style={{ width: 160 }}
										value={filters.interval}
									>
										<MenuItem value="fifteen">15 Minute</MenuItem>
										<MenuItem value="thirty">30 Minute</MenuItem>
										<MenuItem value="sixty">1 Hour</MenuItem>
									</Select>
								</FormControl>
							</div>
						</div>

						<div className="self-end">
							<span>
								<span className="mx-4">
									<CustomButton
										disabled={!filters.room_id || !filters.date || !filters.interval || !filters.room_name}
										fontSize="15px"
										height="43"
										onClick={() => {
											ApplyFilters();
										}}
										variant="secondary"
										width="140px"
									>
										Apply
									</CustomButton>
								</span>
							</span>
						</div>
					</div>
				</div>

				{/* table  */}
				<TableContainer className="student-table-cont" component={Paper} id="Scrollable-table">
					<div style={{ display: 'none' }}>
						<div className="p-32" ref={roomratioRef}>
							<div className="flex flex-row justify-between">
								<div>
									<img alt="" src="assets/images/logos/logo.png" />
								</div>
								<div style={{ textAlign: 'right' }}>
									<Typography
										style={{
											maxWidth: '220px',
										}}
										variant="subtitle1"
									>
										<span style={{ display: 'block', marginBottom: '5px', writingMode: '' }}>
											{user?.data?.school?.address}
										</span>
									</Typography>
									<Typography variant="subtitle1">+ {user?.data?.phone}</Typography>
									<Typography variant="subtitle1">{user?.data?.email}</Typography>
								</div>
							</div>
							<div style={{ marginBottom: '20px' }}>
								<span>
									<strong>Date: </strong>
								</span>
								<span>{moment().format('dddd, DD MMMM YYYY')}</span>
							</div>
							<div className="pdf-heading">
								<h1 className="font-extrabold">Ratio</h1>
							</div>

							<Table className="enrolledtudent-table" stickyHeader style={{ width: '100%' }}>
								<TableHead>
									<TableRow>
										<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
											Time
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
											Student Count
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
											Staff Count
										</TableCell>
										<TableCell className="bg-white studentTableHeader" style={{ width: '15%' }}>
											Ratio
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody className="">
									{isLoading ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												<CircularProgress size={35} />
											</TableCell>
										</TableRow>
									) : !rows.length && !firstLoad ? (
										<TableRow>
											<TableCell align="center" colSpan={8}>
												No Check-ins Check-outs
											</TableCell>
										</TableRow>
									) : (
										rows?.map((row) => (
											<TableRow key={row.id}>
												<TableCell>
													<div className="ratio-numbers">
														{row?.start_time.split(':').slice(0, 2).join(':')}&nbsp;-&nbsp;
														{row?.end_time.split(':').slice(0, 2).join(':')}
													</div>
												</TableCell>
												<TableCell>
													<div className="ratio-numbers">{row?.student_count}</div>
												</TableCell>
												<TableCell>
													<div className="ratio-numbers">{row?.staff_count}</div>
												</TableCell>
												<TableCell>
													<div className="ratio-numbers">
														{row?.student_count}&nbsp;:&nbsp;{row?.staff_count}
													</div>
												</TableCell>
											</TableRow>
										))
									)}
								</TableBody>
							</Table>
						</div>
					</div>
					<Table className="enrolledtudent-table" stickyHeader style={{ width: '100%' }}>
						<TableHead>
							<TableRow>
								<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
									Time
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
									Student Count
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '30%' }}>
									Staff Count
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '15%' }}>
									Ratio
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody className="">
							{firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										Generate your report
									</TableCell>
								</TableRow>
							) : isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : !rows.length && !firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No Check-ins Check-outs
									</TableCell>
								</TableRow>
							) : (
								rows?.map((row) => (
									<TableRow key={row.id}>
										<TableCell>
											<div className="ratio-numbers">
												{row?.start_time.split(':').slice(0, 2).join(':')}&nbsp;-&nbsp;
												{row?.end_time.split(':').slice(0, 2).join(':')}
											</div>
										</TableCell>
										<TableCell>
											<div className="ratio-numbers">{row?.student_count}</div>
										</TableCell>
										<TableCell>
											<div className="ratio-numbers">{row?.staff_count}</div>
										</TableCell>
										<TableCell>
											<div className="ratio-numbers">
												{row?.student_count}&nbsp;:&nbsp;{row?.staff_count}
											</div>
										</TableCell>
									</TableRow>
								))
							)}
						</TableBody>
					</Table>
				</TableContainer>
			</div>
		</FuseAnimate>
	);
}
